import React from "react"
import { useNavigate } from "react-router-dom"
import { Button, Container, Icon } from "semantic-ui-react"

type Props = {

}

export function ServerError({}: Props) {
    const navigate = useNavigate();

    return (
        <Container css={{
            marginTop: '80px'
        }}>
            <h1>
                Erreur serveur
            </h1>
            <div css={{
                marginTop: '30px',
                textAlign: 'center'
            }}>
                <Icon
                    name="exclamation triangle"
                    color="purple"
                    size="massive"
                />
                <div css={{
                    fontSize: '15px',
                    display: 'inline-block'
                }}>
                    <div>
                        Le serveur a rencontré une erreur inattendue. Veuillez réessayer plus tard ou contacter notre support. 
                    </div>
                    <div>
                        Nous nous excusons pour la gêne occasionnée.
                    </div>
                </div>
            </div>
            <div css={{
                marginTop: '20px',
                textAlign: 'center'
            }}>
                <div>
                    <Button color="blue" size="big" onClick={() => navigate(`/`)}>
                        Retour à l'accueil
                    </Button>
                </div>
            </div>
        </Container>
    )
}